import { render, staticRenderFns } from "./DataGridHeader.vue?vue&type=template&id=3b26e4c8&scoped=true&"
import script from "./DataGridHeader.vue?vue&type=script&lang=js&"
export * from "./DataGridHeader.vue?vue&type=script&lang=js&"
import style0 from "./DataGridHeader.vue?vue&type=style&index=0&id=3b26e4c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b26e4c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
